/* eslint-disable import/prefer-default-export */

export const SCREENS = {
  XSM: "360px",
  SM: "640px",
  MD: "960px",
  LG: "1024px",
  XL: "1440px",
};
